import { Mitigations } from '../mitigation/repository';
import { Tactics } from '../tactic/repository';
import { Techniques } from '../technique/repository';
import { TechniqueMitigations } from '../technique-mitigation/repository';
import { AssetTypes } from '../asset-type/repository';

export interface SetAttckParams {
    id: string;
    version: string;
}

export class Attck {
    id?: string;
    version?: string;
    assetTypes: AssetTypes;
    mitigations: Mitigations;
    tactics: Tactics;
    techniques: Techniques;
    techniqueMitigations: TechniqueMitigations;

    constructor(callback: () => void) {
        this.assetTypes = new AssetTypes(callback);
        this.mitigations = new Mitigations(callback);
        this.tactics = new Tactics(callback);
        this.techniques = new Techniques(callback);
        this.techniqueMitigations = new TechniqueMitigations(callback);
    }

    setAttck({ id, version }: SetAttckParams): void {
        this.id = id;
        this.version = version;
    }

    toJSON(): object {
        return {
            id: this.id,
            version: this.version,
            assetTypes: this.assetTypes.toJSON(),
            mitigations: this.mitigations.toJSON(),
            tactics: this.tactics.toJSON(),
            techniques: this.techniques.toJSON(),
            techniqueMitigations: this.techniqueMitigations.toJSON(),
        };
    }
}
